<template>

  <ob-dialog :heading="$t('asset-types.new')" @ok="ok()" @cancel="close()">
    <asset-type-form :asset-type="assetType" />
  </ob-dialog>

</template>

<script>
  import AssetTypeForm from './asset-type-form'
  import ObDialog from '../../shared/components/dialog'

  export default {
    name: 'create-asset-type-dialog',

    data () {
      return {
        assetType: {}
      }
    },

    methods: {
      ok () {
        this.$emit('submit', this.assetType)
      },

      close () {
        this.$emit('submit', false)
      },
    },

    components: {
      ObDialog,
      AssetTypeForm
    }
  }
</script>

<style scoped lang="scss">

</style>
